(function () {
  var addonsRoot = document.getElementById('sst-addons');
  if (!addonsRoot) return;

  // Tab switching
  var tabsWrap = addonsRoot.querySelector('.sst-addons__tabs');
  var tabs = addonsRoot.querySelectorAll('.sst-addons__tab');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      addonsRoot.querySelectorAll('.sst-addons__panel').forEach(function (p) {
        p.classList.remove('is-active');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      var panel = document.getElementById('sst-addons-panel-' + tab.dataset.addonTab);
      if (panel) panel.classList.add('is-active');
      tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    });
  });

  // Drag-to-scroll (mouse) for the tab bar
  if (tabsWrap) {
    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;
    var dragged = false;

    tabsWrap.addEventListener('mousedown', function (e) {
      isDown = true;
      dragged = false;
      tabsWrap.classList.add('is-dragging');
      startX = e.pageX - tabsWrap.offsetLeft;
      scrollLeft = tabsWrap.scrollLeft;
    });
    ['mouseleave', 'mouseup'].forEach(function (evt) {
      tabsWrap.addEventListener(evt, function () {
        isDown = false;
        tabsWrap.classList.remove('is-dragging');
      });
    });
    tabsWrap.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - tabsWrap.offsetLeft;
      var walk = x - startX;
      if (Math.abs(walk) > 5) dragged = true;
      tabsWrap.scrollLeft = scrollLeft - walk;
    });
    tabsWrap.addEventListener(
      'click',
      function (e) {
        if (dragged) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  }

  var form = document.getElementById('sst-product-form');
  if (!form) return;

  form.addEventListener(
    'submit',
    function (evt) {
      var checked = addonsRoot.querySelectorAll('[data-addon-checkbox]:checked');
      if (!checked.length) return;

      var items = Array.prototype.map.call(checked, function (input) {
        return { id: parseInt(input.value, 10), quantity: 1 };
      });

      evt.preventDefault();
      evt.stopImmediatePropagation();

      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function () {
          checked.forEach(function (input) { input.checked = false; });
          HTMLFormElement.prototype.requestSubmit
            ? form.requestSubmit()
            : form.dispatchEvent(new Event('submit', { cancelable: true }));
        })
        .catch(function (e) {
          console.error('Addon add-to-cart failed', e);
          HTMLFormElement.prototype.requestSubmit
            ? form.requestSubmit()
            : form.dispatchEvent(new Event('submit', { cancelable: true }));
        });
    },
    true
  );
})();
